import * as React from 'react'
import { validate } from 'validators'
import { excludeOnlyLowercaseAlphabetAndUnderscore } from 'utils/InputRestrictions'

export default function UseForm({
  mutate,
  validateSchema = null,
  initialState,
}) {
  const [inputs, setInputs] = React.useState(initialState || {})
  const [inputError, setInputError] = React.useState(null)
  const [sending, setSending] = React.useState(false)
  const onChangeInput = (key, e) => {
    setInputs({
      ...inputs,
      [key]:
        key === 'accountId'
          ? excludeOnlyLowercaseAlphabetAndUnderscore(e.currentTarget.value)
          : e.currentTarget.value,
    })
  }

  const submit = () => {
    setSending(true)
    setInputError(null)

    return validate(inputs, validateSchema)
      .then(validInputs => {
        return mutate({ variables: validInputs })
      })
      .then(res => {
        setSending(false)
        return res
      })
      .catch(error => {
        setInputError(error)
        setSending(false)
        throw error
      })
  }

  return {
    submit,
    setInputs,
    inputError,
    onChangeInput,
    sending,
    inputs,
  }
}
